exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-block-header {\n  position: relative;\n  z-index: 0;\n  padding: 20px 0 0 20px;\n  margin: 0 0 22px;\n  word-break: break-word;\n}\n.page-block-content {\n  position: relative;\n  font-size: 34px;\n  min-height: 55.25px;\n  line-height: 1.625;\n  color: var(--text-title);\n  color: var(--text-title);\n  font-weight: 500;\n}\n", ""]);

// exports
